<template>
  <div v-if="unit">
    <div id="unitContentWrapper" class="kt-portlet kt-portlet--height-fluid">
      <div
        class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
      >
        <div
          class="kt-portlet__head-label flex-column justify-center align-baseline pt-4"
          style="width: 100%"
        >
          <div
            class="d-flex justify-content-center align-items-center align-content-center w-100"
          >
            <h3 id="unitTitle" class="kt-portlet__head-title" v-if="!editTitle">
              <template v-if="isPreview">
                <span v-if="unit.module" class="pointer" style="color: #1d2939"
                  >{{ unit.module.name }}:
                </span>
              </template>
              <template v-else>
                <span
                  v-if="unit.module"
                  @click="goToModule(unit.module.id)"
                  class="pointer"
                  >{{ unit.module.name }}:
                </span>
                <span v-else> Uncategorized: </span>
              </template>
              <span>
                {{ unit.name }}
              </span>
            </h3>
            <span class="mr-auto"></span>
            <div class="text-right">
              <v-btn
                color="primaryMain"
                class="primaryMainText--text"
                small
                :to="'/edit/unit/' + unit.id"
                >Edit</v-btn
              >
              &nbsp;
              <v-btn
                v-if="isPreview"
                :to="'/client/lms/unit/' + unit.id"
                color="primary"
                small
                >Go to Unit</v-btn
              >
            </div>
          </div>

          <h5 v-if="unit.is_draft" class="mt-1">Status: Draft</h5>
          <h5 v-else class="mt-1">
            Status: {{ isCompleted ? 'Completed' : 'Open' }}
          </h5>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="d-flex" v-if="unit.series">
          <v-btn
            text
            class="mr-3"
            :disabled="isPreview"
            :loading="loadingMark"
            color="blue-grey darken-1"
            @click="previous"
          >
            <v-icon class="mr-2">fal fa-backward</v-icon>
            Prev
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            class="ml-3"
            :disabled="isPreview"
            :loading="loadingMark"
            color="blue-grey darken-1"
            @click="next"
          >
            Next
            <v-icon class="ml-2">fal fa-forward</v-icon>
          </v-btn>
        </div>
        <div v-if="unit.is_stream">
          <iframe
            :src="unit.content_file"
            style="width: 100%; height: 800px"
          ></iframe>
        </div>
        <div v-if="unit.is_download" class="text-center">
          Click
          <a :href="unit.content_file" download target="_blank">HERE</a> to
          download material
        </div>
        <div class="video-wrapper text-center mt-3">
          <div id="unit-page__unit-desc">
            <template v-if="unit.is_uploading">
              <div
                class="d-flex justify-center align-center items-center text-center"
                style="height: 30vh"
              >
                <h3>
                  The video is transcoding. Please wait and try to refresh
                  later.
                </h3>
              </div>
            </template>
            <template v-else>
              <div class="position-relative">
                <div
                  class="mx-auto embed-container mb-3"
                  id="unit-content"
                  v-html="contents"
                  :class="isAVideoTypeUnit ? 'embed-padding-bottom' : ''"
                />

                <div
                  v-if="showPlayButton"
                  class="play-button position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                >
                  <img
                    id="play-button"
                    src="../../../assets/images/btn_play.png"
                    alt="Play Button"
                    role="button"
                    class="align-self-center"
                    @click="playVimeoVideo"
                  />
                </div>
              </div>
            </template>

            <div class="text-center mt-3 w-75 p-3 description">
              <div v-if="!editDescription">
                <p v-html="unit.description"></p>
                <span small v-for="tag in tags" v-bind:key="tag.id"
                  >#{{ tag.name }}
                </span>
              </div>
            </div>

            <template v-if="!isPreview">
              <div class="d-flex justify-center">
                <template v-if="unit.unit_related_links.length">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <div v-on="on">
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              dark
                              small
                              outlined
                              color="primaryMain"
                              class="primaryMainText--text"
                              text
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon class="mr-2" small> fal fa-link </v-icon>
                              Related Links
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(link, index) in unit.unit_related_links"
                              :key="index"
                            >
                              <v-list-item-title>
                                <v-tooltip top>
                                  <template #activator="{ on }">
                                    <v-btn
                                      block
                                      text
                                      v-on="on"
                                      :href="link.url"
                                      target="_blank"
                                      color="primaryMain"
                                      class="ms-2 primaryMainText--text"
                                    >
                                      {{ link.name }}
                                    </v-btn>
                                  </template>
                                  <span>{{ link.url }}</span>
                                </v-tooltip>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                    <span>Related Links</span>
                  </v-tooltip>
                </template>

                <v-btn
                  dark
                  small
                  outlined
                  color="primary "
                  @click.stop="showShareUnit = true"
                  text
                >
                  <v-icon class="mr-2">fal fa-share-alt</v-icon>
                  Share
                </v-btn>
                <share-unit :unit_id="unit.id" v-model="showShareUnit" />
                <v-btn
                  dark
                  small
                  outlined
                  color="primary "
                  @click.stop="showAssignUnit = true"
                  text
                >
                  <v-icon class="mr-2">fal fa-users-cog</v-icon>
                  Assign
                </v-btn>
                <assign-unit
                  :unit_id="unit.id"
                  v-model="showAssignUnit"
                  :dealers="dealers"
                />
                <v-btn
                  dark
                  small
                  outlined
                  color="primary "
                  @click.stop="showUnitPlaylist = true"
                  text
                >
                  <v-icon class="mr-2">fal fa-layer-plus</v-icon>
                  Add to Playlist
                </v-btn>
                <unit-playlist :unit="unit" v-model="showUnitPlaylist" />
              </div>
            </template>

            <take-quiz
              v-if="quiz && !quizResult"
              :quiz="quiz"
              :is-loading="loadingMark"
              :submit-quiz="checkIfFinished"
            />
            <result-quiz
              v-else
              :retake-quiz="retakeQuiz"
              :result="quizResult"
              :quiz="quiz"
              :is-loading="loadingMark"
              :proceedNext="continueNextUnit"
            />
          </div>

          <v-btn
            v-if="!isAVideoTypeUnit"
            color="primary"
            :disabled="isCompleted"
            :loading="loadingMark"
            @click="checkIfFinished"
            class="mt-3"
          >
            {{ !isCompleted ? 'Mark as Completed' : 'Completed' }}
          </v-btn>

          <notes
            v-if="!isPreview"
            id="unit-page__note"
            :unit-id="$route.params.id"
          >
          </notes>
        </div>
      </div>
    </div>
    <confirm-dialog
      :close-dialog="toggleConfirmDialog"
      :confirm-action="submit"
      :show-dialog="showConfirmDialog"
      :loading="loadingMark"
    >
      You haven't finished watching the video are you sure to mark this as
      completed?
    </confirm-dialog>

    <confirm-dialog
      :close-dialog="toggleRetakeDialog"
      :confirm-action="retakeQuiz"
      :show-dialog="showRetakeConfirmDialog"
      :loading="loadingMark"
    >
      Your current assessment will be removed to retake this quiz? Are you sure
      with this action?
    </confirm-dialog>
    <confirm-dialog
      :close-dialog="closeEdits"
      :confirm-action="toggleAddToLibraryDialog"
      :show-dialog="showUnassignedDialog"
      :loading="loadingMark"
    >
      This unit seems to be un-categorized. <br />Do you want to
      <strong>assign</strong> into Library?
    </confirm-dialog>
    <add-to-library-dialog
      v-on:fetch-units="reloadUnitPage"
      :key="key"
      v-model="addToLibraryDialog"
      :unit="unit"
      :self-assign="true"
    />
  </div>
</template>

<script>
import ShareUnit from '../dialog-box/ShareUnit.vue';
import AssignUnit from '../dialog-box/AssignUnit.vue';
import UnitPlaylist from '../dialog-box/UnitPlaylist.vue';
import Notes from './Notes.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog';
import AddToLibraryDialog from '@/components/dialogs/AddToLibraryDialog';
import Assignment from '@/components/client-lms/UnitPage/partials/Assignment.vue';
import TakeQuiz from '@/components/client-lms/UnitPage/partials/TakeQuiz';
import ResultQuiz from '@/components/client-lms/UnitPage/partials/ResultQuiz';
import EventBus from '@/plugins/eventBus';
import {
  filter as _filter,
  find as _find,
  findIndex as _findIndex,
  forOwn as _forOwn,
  isEmpty as _isEmpty,
  each as _each,
  some as _some,
  forEach as _forEach,
  map as _map,
} from 'lodash-es';

export default {
  name: 'LiveMain',

  props: {
    unit: Object,
    isPreview: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ConfirmDialog,
    Notes,
    ShareUnit,
    AssignUnit,
    UnitPlaylist,
    AddToLibraryDialog,
    Assignment,
    TakeQuiz,
    ResultQuiz,
  },

  data: () => ({
    showRetakeConfirmDialog: false,
    isLoading: false,
    editTags: false,
    editDescription: false,
    editTitle: false,
    showToolTip: true,
    showConfirmDialog: false,
    loadingMark: false,
    isFetching: false,
    showShareUnit: false,
    showAssignUnit: false,
    showUnitPlaylist: false,
    quizDialog: false,
    modprog: 78,
    answers: [],
    player: null,
    vPlayer: null,
    quizAnswered: false,
    downloadLinks: [
      {
        title: 'Salesbook',
        link: 'https://docs.google.com/document/d/1yXDXBMDhBqxUrh_n2AWlAUtIYPOSFCCbPgtn74jOdsw/edit?usp=sharing',
      },
      {
        title: 'Call Guides',
        link: 'https://docs.google.com/presentation/d/1HEhwl-N4R8zf1gNiNhV_xxOo5uCj2qlM0R8b7tG-2fk/edit?usp=sharing',
      },
      {
        title: 'File Manager',
        link: 'https://file.webinarinc.com/',
      },
    ],
    unitProgress: [
      {
        type: 'videoWatched',
        title: 'Watched the Video',
        description: 'you will be scored once you played the video',
        checked: false,
        hide: false,
      },
      {
        type: 'videoCompleted',
        title: 'Finished the Video',
        description:
          'you will be scored once you finished watching the whole video',
        checked: false,
        hide: false,
      },
      {
        type: 'quizCompleted',
        title: 'Answered the Quiz',
        description: 'you will be scored once you answered the provided quiz',
        checked: false,
        hide: false,
      },
      {
        type: 'completedUnit',
        title: 'Completed the Unit',
        description: 'you will be scored once you mark the unit as completed',
        checked: false,
        hide: true,
      },
    ],
    dealers: [],
    relatedLinkShow: true,
    key: 0,
    addToLibraryDialog: false,
    saveTags: [],
    debounce: null,
    showUnassignedDialog: false,
    tab: null,
    items: ['web', 'shopping', 'videos', 'images', 'news'],
    showPlayButton: true,
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  }),

  mounted() {
    this.getDealers();

    if ((this.isAdmin || this.isManager) && !this.unit.series) {
      this.toggleUnassignedDialog();
    }

    EventBus.$on('finishedVideo', (unit) => {
      this.unit.is_finished_watching = true;
      this.markAsCompleted();
    });

    EventBus.$on('nextUnit', () => {
      this.next();
    });
  },
  computed: {
    user() {
      return this.$auth.user();
    },

    isAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },

    isManager() {
      return _some(this.$auth.user().roles, { name: 'account-manager' });
    },

    isAVideoTypeUnit() {
      return this.unit.content.search('iframe') < 0 ? false : true;
    },
    isVimeoVideo() {
      return this.unit.content.search('vimeo') < 0 ? false : true;
    },
    tags() {
      return this.unit.tags;
    },
    contents() {
      return this.playerFullscreen(this.unit.content);
    },
    quiz() {
      return this.unit.quiz;
    },
    quizResult() {
      return this.$store.state.clientUnit.quizResult;
    },
    quizResultForm() {
      return this.quizResult ? JSON.parse(this.quizResult.quiz_form) : null;
    },
    userId() {
      return this.$auth.user().id;
    },
    isCompleted() {
      const unitCompleted = _find(this.unitProgress, { type: 'completedUnit' });
      if (unitCompleted.checked) {
        return true;
      }

      return (
        this.$store.state.clientUnit.selectedItem.is_completed === 1 ||
        this.$store.state.clientUnit.selectedItem.is_completed === true
      );
    },
    unitProgressRender() {
      const filtered = _filter(this.unitProgress, { hide: false });

      return _forOwn(filtered);
    },
    played: {
      get() {
        const watchedIndex = 0;
        return this.unitProgress[watchedIndex].checked;
      },
      set() {
        this.checkUnitProgress('videoWatched');
      },
    },
    loadTags() {
      return this.$store.state.units.tags;
    },
    currentRouteName() {
      return this.$route.name;
    },
  },

  created() {
    this.isPreview = this.currentRouteName == 'PreviewUnitPage' ? true : false;
    window.scrollTo(0, 0);

    if (this.loadTags.length <= 0) {
      console.log('fetching tags');
      this.$store.dispatch('units/fetchTags').then(({ data }) => {
        this.$store.commit('units/setTags', data);
      });
    }
  },

  methods: {
    toggleRetakeDialog() {
      this.showRetakeConfirmDialog = !this.showRetakeConfirmDialog;
    },
    toggleUnassignedDialog() {
      this.showUnassignedDialog = true;
    },
    goToModule(id) {
      this.$router.push({
        name: 'CertificationModulePage',
        params: {
          id,
        },
      });
    },
    quickUpdate() {
      this.isLoading = true;
      _forEach(this.unit.tags, (tag) => {
        typeof tag === 'object'
          ? this.saveTags.push(tag.id)
          : this.saveTags.push(tag);
      });

      this.axios
        .patch('client/lms/quickupdate/unit', {
          id: this.unit.id,
          name: this.unit.name,
          description: this.unit.description,
          quiz_id: this.unit.quiz_id,
          tags: this.saveTags,
        })
        .then((response) => {
          this.$notify('success', `${this.unit.name} updated!`);
        })
        .finally((data) => {
          this.saveTags = [];
          this.closeEdits();
        });
    },
    closeEdits() {
      this.editTitle = false;
      this.editTags = false;
      this.editDescription = false;
      this.addToLibraryDialog = false;
      this.isLoading = false;
      this.showUnassignedDialog = false;
    },
    toggleEditTitle() {
      this.editTitle = !this.editTitle;
    },
    toggleEditTags() {
      this.editTags = !this.editTags;
    },
    toggleEditDescription() {
      this.editDescription = !this.editDescription;
    },
    forceRerender() {
      this.key += 1;
    },
    toggleAddToLibraryDialog() {
      this.showUnassignedDialog = false;
      this.forceRerender();
      this.addToLibraryDialog = !this.addToLibraryDialog;
    },
    reloadUnitPage() {
      EventBus.$emit('RELOAD_UNIT_PAGE');
    },
    canEdit(company_id) {
      if (this.isAdmin) {
        return true;
      }

      if (this.isManager) {
        return this.user.dealer_id == company_id;
      }

      return false;
    },
    checkIfFinished() {
      if (this.unit.is_finished_watching) {
        this.submit();
      } else {
        this.toggleConfirmDialog();
      }
    },
    submit() {
      if (!this.unit.quiz) {
        this.markAsCompleted();
      } else {
        this.submitQuiz();
      }
      this.showConfirmDialog = false;
    },
    toggleConfirmDialog() {
      this.showConfirmDialog = !this.showConfirmDialog;
    },
    playerFullscreen(str) {
      let isVimeo = str.search('vimeo') < 0 ? false : true;
      let ret =
        str.substring(0, str.search('iframe') + 7) +
        'id="unit-video-' +
        this.unit.id +
        '" allowfullscreen="allowfullscreen" ' +
        str.substring(str.search('iframe') + 7, str.length);

      return isVimeo ? ret : str;
    },
    isQuizAlreadyAnswered() {
      this.axios
        .get(`/client/lms/quiz/${this.unit.quiz_id}`, {
          params: {
            unit_id: this.unit.id,
          },
        })
        .then(({ data }) => {
          this.$store.commit('clientUnit/setQuizResult', data.data);
          this.markAsCompleted();
        })
        .catch((error) => {
          this.$store.commit('clientUnit/setQuizResult', null);
        });
    },

    selectAnswer(answerId, questionId) {
      const answer = {
        questionId,
        answerId,
      };

      const existingIndex = _findIndex(this.answers, answer);

      if (existingIndex === -1) {
        return this.answers.push(answer);
      }

      return this.answers.splice(existingIndex, 1);
    },

    isUserAnswer(userAnswersId, currentAnswerId) {
      return userAnswersId.includes(currentAnswerId);
    },

    getAnswers() {
      let answers = [];
      _map(this.unit.quiz.questions, (question) => {
        answers = answers.concat(question.user_answer);
      });

      return answers;
    },

    submitQuiz() {
      const answers = this.getAnswers();
      this.loadingMark = true;
      this.axios
        .post('client/lms/process/quiz', {
          answers: answers,
          quiz_form: this.unit.quiz.questions,
          quiz_id: this.unit.quiz_id,
          unit_id: this.unit.id,
        })
        .then(() => {
          this.quizAnswered = false;
          this.isQuizAlreadyAnswered();
        })
        .finally(() => {
          this.loadingMark = false;
        });
    },

    retakeQuiz() {
      if (this.showRetakeConfirmDialog) {
        this.loadingMark = true;
        this.axios
          .post('client/lms/retake/quiz', {
            quiz_id: this.unit.quiz_id,
            unit_id: this.unit.id,
          })
          .then(() => {
            this.$store.commit('clientUnit/setQuizResult', null);
          })
          .finally(() => {
            this.loadingMark = false;
            this.showRetakeConfirmDialog = false;
          });
      } else {
        this.toggleRetakeDialog();
      }
    },

    markAsCompleted() {
      this.loadingMark = true;
      this.$store
        .dispatch('markAsCompleted/markAsCompleted', {
          playlistId: this.$route.params.playlistId,
          type: this.$store.state.markAsCompleted.type,
          unitId: this.$store.state.markAsCompleted.current_unit.id,
        })
        .then(({ data }) => {
          if (this.unit.series && this.unit.module) {
            this.$store.commit(
              'relatedUnits/setIsCompletedToTrue',
              this.$store.state.markAsCompleted.current_unit.id
            );
          }
          this.$store.commit('markAsCompleted/setIsCompleted', true);
          this.$store.commit('clientUnit/setCompleted', true);
          this.loadingMark = false;
          this.$emit('complete-unit');
          this.showConfirmDialog = false;
        });
    },
    addToFavoriteDialog() {
      this.$swal({
        text: 'Successfully added to Favorite list.',
        icon: 'success',
      });
    },
    next() {
      if (this.unit.content_file !== null) {
        this.markAsCompleted();
      }

      if (this.$route.params.playlistId) {
        return this.navigateAroundPlaylist('next');
      }

      return this.axios
        .post('client/lms/related-units', {
          unitId: this.unit.id,
          type: 'single',
          action: 'next',
        })
        .then(({ data }) => {
          if (data !== null) {
            return this.$router.push({
              name: 'UnitPage',
              params: {
                id: data,
              },
            });
          }

          return this.$notify('warning', 'This is the last unit in the list.');
        });
    },
    continueNextUnit() {
      this.loadingMark = true;
      this.$store
        .dispatch('markAsCompleted/markAsCompleted', {
          playlistId: this.$route.params.playlistId,
          type: this.$store.state.markAsCompleted.type,
          unitId: this.$store.state.markAsCompleted.current_unit.id,
        })
        .then(({ data }) => {
          if (this.unit.series && this.unit.module) {
            this.$store.commit(
              'relatedUnits/setIsCompletedToTrue',
              this.$store.state.markAsCompleted.current_unit.id
            );
          }
          this.$store.commit('markAsCompleted/setIsCompleted', true);
          this.$store.commit('clientUnit/setCompleted', true);
          this.next();
        })
        .catch(() => {
          this.$notify('error', 'Something went wrong, please try again.');
        });
    },
    previous() {
      const { type } = this.$store.state.relatedUnits;
      if (type === 'playlist') {
        return this.navigateAroundPlaylist('back');
      }
      return this.axios
        .post('client/lms/related-units', {
          unitId: this.unit.id,
          type: 'single',
          action: 'prev',
        })
        .then(({ data }) => {
          if (data !== null) {
            return this.$router.push({
              name: 'UnitPage',
              params: {
                id: data,
              },
            });
          }

          return this.$notify('warning', 'This is the first unit in the list.');
        });
    },
    navigateAroundPlaylist(type) {
      if (type === 'back') {
        const prevId = this.$store.getters[
          'relatedUnits/getPrevUnitInPlaylist'
        ](this.unit.id);

        if (Number.isInteger(prevId)) {
          return this.$router.push({
            name: 'PlaylistUnitPage',
            params: {
              id: prevId,
              playlistId: this.$route.params.playlistId,
            },
          });
        }

        return this.$notify('warning', 'This is the first unit in the list.');
      }

      const nextId = this.$store.getters['relatedUnits/getNextUnitInPlaylist'](
        this.unit.id
      );

      if (Number.isInteger(nextId)) {
        return this.$router.push({
          name: 'PlaylistUnitPage',
          params: {
            id: nextId,
            playlistId: this.$route.params.playlistId,
          },
        });
      }

      return this.$notify('warning', 'This is the last unit in the list.');
    },
    hideVideoUnitProgressTasks() {
      const tasks = _forOwn(this.unitProgress);
      const quizCompletedTask = _find(this.unitProgress, {
        type: 'quizCompleted',
      });

      tasks.forEach((item, index) => {
        let value = item.type !== 'completedUnit';

        // if quiz exist in this unit, skip hide of quiz
        if (item.type === 'quizCompleted' && !item.hide) {
          value = false;
        }

        // if item is a "completedUnit" and
        // quiz exist in this unit, hide this item
        if (item.type === 'completedUnit' && !quizCompletedTask.hide) {
          value = true;
        }

        this.unitProgress[index].hide = value;
      });
    },
    getDealers() {
      this.$http
        .get('/dealers')
        .then((response) => {
          _each(response.data, (dealer) => {
            this.dealers.push(dealer);
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    playVimeoVideo() {
      const player = document.querySelector(
        'iframe#unit-video-' + this.unit.id
      );
      this.vPlayer = new Vimeo.Player(player);

      this.vPlayer.play();

      this.vPlayer.on('play', () => {
        this.showPlayButton = false;
      });

      this.vPlayer.on('pause', () => {
        this.showPlayButton = true;
      });
    },

    pauseVimeoVideo() {
      const player = document.querySelector(
        'iframe#unit-video-' + this.unit.id
      );
      this.vPlayer = new Vimeo.Player(player);
      this.vPlayer.pause();

      this.showPlayButton = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.editor, .output {
  height: 10rem;
}


         .description {
           margin: auto;
         }

         .kt-portlet__head-title {
           font-size: 1.5rem!important
         }

#unitTitle {
  font-size: 1.8rem!important
}


.embed-container {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  min-height: 0 ;
}

.embed-container >>> iframe,
.embed-container >>> object,
.embed-container >>> embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}


.embed-container.embed-padding-bottom {
  padding-bottom: 56.25%;
}
.pointer {
  cursor: pointer;
}

.play-button img{
  height: 120px
}
</style>
